export default __webpack_public_path__ + "static/media/strategyImg1.80e01a8b.jpg";